module.exports = __webpack_public_path__ + "img/kefu.1836feda.png";